
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Ce qu’il faut savoir sur les cartes de dangers</div>
    <p>{`Les cartes de dangers naturels ont commencé à apparaître en Suisse au 20ème siècle, d’abord pour les avalanches. Dans les années 1990, après une série d’inondations, la Confédération a mandaté les cantons pour établir des cartes systématiques sur tout le territoire. Depuis 10 à 15 ans, l’utilisation de modèles informatiques, en plus des visites de terrain par des experts, ont permis d’établir des cartes beaucoup plus précises.`}</p>
    <p>{`Ces cartes sont mises à jour graduellement. Si un ouvrage de protection comme une digue est construit, le niveau de danger d’un lieu peut être diminué, passer de rouge à jaune par exemple. Mais ce processus demande du temps, car il exige une mise à l’enquête formelle au niveau communal. Les cartes que nous utilisons sont basées sur les données officielles disponibles aujourd’hui (mai 2019), mais elles ne traduisent pas toujours la réalité actuelle sur le terrain.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;